import { c as _c } from "react/compiler-runtime";
import { Modal } from '@systemeio/ui';
import { actionItems } from 'modules/automation-rules/actions/constants/action-items';
import { AutomationRuleActionsEnum } from 'modules/automation-rules/actions/enums/action-enum';
import { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useAllowedActions } from '../hooks/use-allowed-actions';
import { AddIcon } from '@systemeio/ui/icons';
interface AddActionModalProps {
  isReady: boolean;
  onAddAction: (action: AutomationRuleActionsEnum) => void;
}
const AddActionModal = t0 => {
  const $ = _c(28);
  const {
    isReady,
    onAddAction
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const allowedActions = useAllowedActions();
  const t1 = !isReady;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpened(true);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = `group flex self-center rounded-full outline-hidden ${!isReady && "pointer-events-none"}`;
  const t4 = `${!isReady && "fill-fill-primary/70 animate-pulse"} main-transition-colors group-hover:fill-brand-primary group-focus-visible:fill-brand-primary fill-fill-primary h-[30px] w-[30px]`;
  let t5;
  if ($[1] !== t4) {
    t5 = <AddIcon className={t4} />;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t1 || $[4] !== t3 || $[5] !== t5) {
    t6 = <button disabled={t1} onClick={t2} className={t3}>{t5}</button>;
    $[3] = t1;
    $[4] = t3;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t) {
    t7 = t("dashboard.automation_rule.edit.add_action");
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpened(false);
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== allowedActions || $[11] !== onAddAction || $[12] !== t) {
    let t10;
    if ($[14] !== allowedActions) {
      t10 = el => allowedActions.includes(el.slug);
      $[14] = allowedActions;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] !== onAddAction || $[17] !== t) {
      t11 = (action, idx) => <button onClick={() => {
        onAddAction(action.slug);
        setOpened(false);
      }} key={idx} className={`group flex w-full gap-3 text-left outline-hidden ${idx !== 0 && "border-text-secondary/30 border-t pt-5"}`}><div className="[&>svg]:main-transition-colors [&>svg]:group-hover:fill-brand-primary [&>svg]:group-focus-visible:fill-brand-primary [&>svg]:h-[40x] [&>svg]:w-[40px] w-[40px]">{action.icon}</div><div className="flex flex-col gap-1"><span className="text-text-primary text-[15px] font-bold">{t(action.title)}</span><span>{t(action.description)}</span></div></button>;
      $[16] = onAddAction;
      $[17] = t;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    t9 = actionItems.filter(t10).map(t11);
    $[10] = allowedActions;
    $[11] = onAddAction;
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <div className="flex flex-col gap-5 px-10">{t9}</div>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== opened || $[22] !== t10 || $[23] !== t7) {
    t11 = <Modal title={t7} opened={opened} onClose={t8}>{t10}</Modal>;
    $[21] = opened;
    $[22] = t10;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t6) {
    t12 = <>{t6}{t11}</>;
    $[25] = t11;
    $[26] = t6;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
export default AddActionModal;